import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { getLocationsByCity, getLocationsLoading } from 'SRC/modules/geoObjects/locations/selectors'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

const Location = ({
  locationsByCity,
  locationsLoading
}) => {
  const formik = useFormikContext()

  const locationOptions = locationsByCity && formik.values.newUser && formik.values.newUser.city &&
    Number(formik.values.newUser.city) !== -1 && Array.isArray(locationsByCity[formik.values.newUser.city])
		? locationsByCity[formik.values.newUser.city].map(location => ({
			id: `${location.id}`,
			label: location.label,
			value: `${location.value}`
		}))
		: []

  let locationError = ''

  if (formik.touched.newUser && formik.touched.newUser.location) {
    locationError = formik.errors.newUser && formik.errors.newUser.location
  }

  const isDisabled = locationsLoading || !formik.values.newUser.city ||
    Number(formik.values.newUser.city) === -1 || !Array.isArray(locationOptions) || !locationOptions.length

  return (
    <Wrapper isError={!!locationError}>
      <SelectDropdown
        id='newUser_location'
        title='Lokacija'
        isDisabled={isDisabled}
        isSearchable
        isRequired
        value={formik.values.newUser.location || -1}
        options={locationOptions}
        onChange={async location => {
          await formik.setFieldValue('newUser.location', location)

          if (!formik.touched.newUser || !formik.touched.newUser.location) {
            formik.setFieldTouched(`newUser.location`, true)
          }
        }}
      />

      <ErrorMessage
        name='newUser.location'
        render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
      />
    </Wrapper>
  )
}

Location.displayName = 'Location'

const mapStateToProps = state => {
  return {
    locationsByCity: getLocationsByCity(state),
    locationsLoading: getLocationsLoading(state)
  }
}

export default connect(mapStateToProps)(Location)
